import React from 'react';
import { connect } from 'react-redux';
import {
  Link,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';
import {
  Layout,
  Menu,
} from 'antd';
import {
  PieChartOutlined,
  HomeOutlined,
  FileOutlined,
  FileDoneOutlined,
  TeamOutlined,
  BlockOutlined,
  ToolOutlined,
  UserOutlined,
  LoadingOutlined,
  LogoutOutlined,
} from '@ant-design/icons';

import { withTranslation } from 'react-i18next';

import { LayoutStyle, ThemeColors } from '@constants/Theme'

import Portfolio from './Portfolio';
import Properties from './Properties';
import Documents from './Documents';
import Tasks from './Tasks';
import Owners from './Owners';
import Listings from './Listings';
import RepairsData from './RepairsData';
import Profile from './Profile';
import NotFound from './NotFound';

const iconMap = {
  "pie-chart": PieChartOutlined,
  "home": HomeOutlined,
  "file": FileOutlined,
  "file-done": FileDoneOutlined,
  "team": TeamOutlined,
  "block": BlockOutlined,
  "tool": ToolOutlined,
  "user": UserOutlined,
};

const routes = [
  {
    key: "/portfolio",
    style: { marginTop: 0 },
    icon: "pie-chart",
    ttext: "Portfolio.Title",
    component: Portfolio,
  },{
    key: "/properties",
    icon: "home",
    ttext: "Properties.Title",
    component: Properties,
  },{
    key: "/documents",
    icon: "file",
    ttext: "Documents.Title",
    component: Documents,
  },{
    key: "/tasks",
    icon: "file-done",
    ttext: "Tasks.Title",
    component: Tasks,
  },{
    key: "/owners",
    icon: "team",
    ttext: "Owners.Title",
    component: Owners,
  },{
    key: "/listings",
    icon: "block",
    ttext: "Listings.Title",
    component: Listings,
  },{
    key: "/repairs_data",
    icon: "tool",
    ttext: "RepairsData.Title",
    component: RepairsData,
  },{
    key: "/profile",
    icon: "user",
    ttext: "Profile.Title",
    component: Profile,
  }
];

class AuthenticatedRouter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggingOut: false,
      collapsed: false,
    };
    this.onLogout = this.onLogout.bind(this);
  }

  onLogout() {
    this.setState({ isLoggingOut: true })
  }

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  }

  renderSider() {
    const { location } = this.props;
    const selected = routes.filter((route) => {
      return location.pathname.includes(route.key);
    }).map((route) => { return route.key });

    return (
      <Layout.Sider
        collapsible
        collapsed={ this.state.collapsed }
        onCollapse={ this.onCollapse }
      >
        <Link to="/">
          <h3
            style={{
              ...LayoutStyle.siderTitle,
              color: this.state.collapsed ? "rgba(0,0,0,0)" : "white",
            }}
          >
            { this.props.orgName }
          </h3>
        </Link>
        <Menu theme="dark" selectedKeys={ selected } mode="inline">
          {
            routes.map((route) => {
              const IconComponent = iconMap[route.icon];
              return (
                <Menu.Item key={ route.key } style={ route.style || {} }>
                  <Link
                    to={ route.key }
                    onClick={ () => {} }
                  >
                    { IconComponent && <IconComponent /> }
                    <span>{ this.props.t(route.ttext) }</span>
                  </Link>
                </Menu.Item>
              );
            })
          }
          <Menu.Item style={{ marginTop: 20 }} key="/users/sign_out">
            <a
              href="/users/sign_out"
              onClick={ this.onLogout }
            >
              { this.state.isLoggingOut
                ? <LoadingOutlined style={{ color: ThemeColors.red }} />
                : <LogoutOutlined style={{ color: ThemeColors.red }} />
              }
              <span style={{ color: ThemeColors.red }}>
                { this.props.t("sider.SignOut") }
              </span>
            </a>
          </Menu.Item>
        </Menu>
      </Layout.Sider>
    )
  }

  render() {
    return (
      <Layout style={ LayoutStyle.outerLayoutStyle }>
        { this.renderSider() }
        <Layout.Content style={ LayoutStyle.routerContentStyle }>
          <Routes>
            <Route path="/" element={ <Navigate to={ routes[0].key } replace /> } />
            {
              routes.map((route, index) => (
                <Route
                  key={ index.toString() }
                  path={ `${route.key}/*` }
                  element={ <route.component /> }
                />
              ))
            }
            <Route path="/login" element={ <Navigate to={ routes[0].key } replace /> } />
            <Route path="/sign_up" element={ <Navigate to={ routes[0].key } replace /> } />
            <Route path="*" element={ <NotFound /> } />
          </Routes>
        </Layout.Content>
      </Layout>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    orgName: state.organizationReducer.name,
  };
}

const mapDispatchToProps = (dispatch, props) => {
  return {
  }
}

export default withTranslation('common')(connect(mapStateToProps, mapDispatchToProps)(AuthenticatedRouter));
